export default __webpack_public_path__ + "static/Theinhardt-Medium-subset-3e373fb0c2458c55daaf34b729115b11.woff2";